<template>
  <div>
    <!-- 历史对话记录弹框 -->
    <el-dialog
      :visible.sync="visible"
      width="480px"
      :before-close="close"
      :close-on-click-modal="false"
      :append-to-body="true"
      custom-class="custom-dark-dialog"
      top="15vh"
    >
      <button class="modal-close-btn" @click="close">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <h3 class="modal-title">{{ $t('components.aiAssessment.tooltips.historicalRecords') }}</h3>

      <div
        class="history-list-container"
        v-loading="isloading"
        :element-loading-text="$t('common.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div v-if="Object.keys(historyList).length <= 0" class="no-history">
          <span>
            <aicanvasIcons name="emptyIcon" />
          </span>
          <span class="emptyText">暂无对话</span>
        </div>
        <div v-else>
          <div
            class="history-group-wrapper"
            v-for="(value, key) in historyList"
            :key="key"
          >
            <div class="history-group-title">{{ key }}</div>
            <el-tooltip
              v-for="(item, index) in value"
              :key="index"
              effect="dark"
              :content="item.title"
              placement="top-start"
              :open-delay="400"
              popper-class="custom-history-tooltip"
            >
              <div
                class="history-list-item transition"
                @click="selectHistory(item)"
              >
                {{ item.title }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 删除确认弹框 -->
    <el-dialog
      class="dialog-style-public"
      title="确认删除"
      :visible.sync="showConfirmDialog"
      width="360px"
    >
      <span class="tiptext">此操作将永久删除对话，是否确定?</span>
      <span slot="footer" class="dialog-footer btnbox">
        <el-button class="btnstyle" @click="showConfirmDialog = false"
          >取消</el-button
        >
        <el-button class="btnstyle" type="success" @click="deleteHistory"
          >删除</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import aicanvasIcons from "@/components/icons/aiIcons.vue";
import { conversationLog } from "@/aips/canvas/aiCanvasApi.js";
export default {
  name: "DialogHistory",
  components: {
    aicanvasIcons,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isloading: true,
      aiModelType: "ADDRESS_ANALYSIS",
      showConfirmDialog: false,
      currentDeleteItem: null,
      hoveredItem: null,
      showActionsFor: null,
      activeItem: null,
      historyList: {},
    };
  },
  methods: {
    //请求历史会话
    getConversationLog() {
      conversationLog({ aiModelType: this.aiModelType })
        .then((res) => {
          console.log("我是会话记录");
          console.log(res.data);
          this.isloading = false;
          if (res.code == 200) {
            this.historyList = res.data;
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    // 关闭历史对话弹框
    close() {
      this.$emit("updateVisible");
    },

    // 创建新对话
    createNewChat() {
      // this.$emit("create-new-chat");
      // this.close();
    },

    // 显示操作菜单
    showActions(item) {
      this.showActionsFor =
        this.showActionsFor === item.conversationId
          ? null
          : item.conversationId;
    },

    // 编辑历史记录
    editHistory(item) {
      // 暂不实现编辑功能
      this.showActionsFor = null;
    },

    // 确认删除
    confirmDelete(item) {
      this.currentDeleteItem = item;
      this.showConfirmDialog = true;
      this.showActionsFor = null;
    },

    // 删除历史记录
    deleteHistory() {
      // if (this.currentDeleteItem) {
      //   const index = this.historyList.findIndex(
      //     (item) => item.id === this.currentDeleteItem.id
      //   );
      //   if (index !== -1) {
      //     this.historyList.splice(index, 1);
      //   }
      // }
      // this.showConfirmDialog = false;
      // this.currentDeleteItem = null;
    },

    // 选择历史记录
    selectHistory(item) {
      this.activeItem = item.conversationId;
      // 存储到本地存储
      localStorage.setItem("activeConversationId", item.conversationId);
      console.log(this.activeItem);

      // 确保传递的数据结构完整，避免 undefined 导致 JSON 解析错误
      const sanitizedItem = {
        conversationId: item.conversationId,
        canvasId: item.canvasId || null,
        branchId: item.branchId || null,
        title: item.title || null
      };

      this.$emit("getMessageList", sanitizedItem);
    },
  },
  mounted() {},
  // 当组件关闭时重置状态
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getConversationLog();
      }
    },
  },
};
</script>
<style lang="less">
@import "@/assets/css/publicStyle/dialog.less";
@import "@/assets/css/publicStyle/button.less";
@import "@/assets/css/newhomepage/homemain-common.less";
</style>
<style lang="less" scoped>
.no-history {
  color: #87909f;
  font-family: "PingFang SC";
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 300px;
  margin-bottom: 16px;
}

.tiptext {
  color: var(--web-color-text-primary, #0d0e0f);
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  .btnstyle {
    width: 52px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
